import { createRouter, createWebHistory } from 'vue-router'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'

const routes = [
  {
    path: '/',
    redirect: '/dashboard'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// If already logged in, skip the login page
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  if (token && to.path === '/login') {
    next('/dashboard')
  } else {
    next()
  }
})

export default router 